import { AutoComplete } from "antd";
import { Subject } from "rxjs";
import { SetState } from "../../../types/SetState";

export const ProfileAutocomplete = <T extends string>({
  nameOptions,
  name,
  subject$,
  array,
  setArray,
  index,
  targetNameModalType,
  setNameModalType,
  large = false,
}: {
  large?: boolean;
  targetNameModalType: 0 | 1 | 2 | 3 | null;
  setNameModalType: SetState<0 | 1 | 2 | 3 | null>;
  nameOptions: {
    value: string;
    label: string;
    logo?: string;
    id?: string;
    full_name?: string;
    business_name?: string;
    custom_url?: string;
    type?: "professional" | "business";
  }[];
  subject$: Subject<string>;
  name: string;
  array: ({
    name: string;
    user?: string;
    id?: string;
    type?: "professional" | "business";
    logo?: string;
  } & (T extends "" ? {} : Record<T, string>))[];
  setArray: SetState<
    ({
      name: string;
      user?: string;
      id?: string;
      type?: "professional" | "business";
    } & (T extends "" ? {} : Record<T, string>))[]
  >;
  index: number;
  dataProperty: T;
}) => {
  const excludedIds = array.map((el) => el.user || el.id).filter((el) => !!el);
  excludedIds.splice(index, 1);

  return (
    <AutoComplete
      autoFocus
      {...(large ? { size: "large" } : {})}
      style={{ width: "100%" }}
      options={nameOptions.filter(
        (option) => !option.id || !excludedIds.includes(option.id)
      )}
      value={name}
      onBlur={() => subject$.next("")}
      onSelect={(_, { id, type, full_name, logo }) => {
        const newArray = [...array];
        newArray[index].name = full_name?.toString() ?? "";
        if (id) newArray[index].user = id;

        newArray[index].type = type;
        newArray[index].logo = logo;

        setArray(newArray);
      }}
      onSearch={(text) => {
        console.log(targetNameModalType);
        setNameModalType(targetNameModalType);

        subject$.next(text);
        const newDirectors = [...array];
        newDirectors[index].name = text;
        newDirectors[index].logo = undefined;
        newDirectors[index].user = undefined;

        setArray(newDirectors);
      }}
      placeholder="Enter name / search"
    />
  );
};
